import React from "react";

const Footer = () => {
  return (
    <footer className="p-0 footer-light border-top position-relative fffooter">
      <div className="container position-relative pt-5">
        <div className="row justify-content-center pt-5 sm-pt-40px fs-5">
          <div className="col-6 col-xl-3 col-lg-12 col-sm-6 last-paragraph-no-margin text-xl-start text-lg-center order-sm-1 lg-mb-50px sm-mb-30px">
            <a href="#" className="footer-logo mb-15px d-inline-block">
              <img
                data-at2x="images/demo-it-business-logo-black@2x.png"
                alt=""
                data-cfsrc="images/demo-it-business-logo-black.png"
                style={{ display: "none", visibility: "hidden" }}
              />
              <noscript>
                <img
                  src="images/demo-it-business-logo-black.png"
                  data-at2x="images/demo-it-business-logo-black@2x.png"
                  alt=""
                />
              </noscript>
            </a>
            <p className="lh-28 w-90 xl-w-100 mx-lg-auto mx-xl-0">
              Gearing your company through an innovative strategy.
            </p>
            <div className="elements-social social-icon-style-02 mt-15px">
              <ul className="medium-icon dark" >
                <li className="my-0">
                  <a className="facebook" href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                </li>
                <li className="my-0">
                  <a className="dribbble" href="http://www.dribbble.com/" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-dribbble"></i>
                  </a>
                </li>
                <li className="my-0">
                  <a className="twitter" href="https://www.twitter.com/" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-twitter"></i>
                  </a>
                </li>
                <li className="my-0">
                  <a className="instagram" href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-6 col-xl-2 col-lg-3 col-sm-4 xs-mb-30px order-sm-3 order-lg-2">
            <span className="fw-600 d-block text-dark-gray mb-5px">Company</span>
            <ul>
              <li><a href="/our-concern">Who we are</a></li>
              <li>
                <a href="demo-it-business-services.html">Our services</a>
                <div className="bg-dark-gray fw-600 text-white lh-22 text-uppercase border-radius-30px ps-10px pe-10px fs-10 ms-10px d-inline-block align-middle">
                  Hot
                </div>
              </li>
              <li><a href="#">Our clients</a></li>
              <li><a href="/contact">Contact us</a></li>
            </ul>
          </div>

          <div className="col-6 col-xl-2 col-lg-3 col-md-5 col-sm-4 xs-mb-30px order-sm-4 order-lg-3">
            <span className="fw-600 d-block text-dark-gray mb-5px">Services</span>
            <ul>
              <li><a href="#">Planning</a></li>
              <li><a href="#">Research</a></li>
              <li><a href="#">Consulting</a></li>
              <li><a href="#">Analysis</a></li>
            </ul>
          </div>

          <div className="col-6 col-xl-2 col-lg-3 col-md-3 col-sm-4 xs-mb-30px order-sm-5 order-lg-4">
            <span className="fw-600 d-block text-dark-gray mb-5px">Need help?</span>
            <span>Call us directly?</span>
            <span className="d-block mb-10px">
              <a className="text-dark-gray fw-600" href="tel:1235678901">
                (123) 567 8901
              </a>
            </span>
            <span>Need support?</span>
            <a href="#" className="text-dark-gray fw-600">
              <span className="__cf_email__" data-cfemail="d0b8b5bca090b4bfbdb1b9befeb3bfbd">
                [email&#160;protected]
              </span>
            </a>
          </div>

          <div className="col-xl-3 col-lg-3 col-sm-6 md-mb-50px sm-mb-30px xs-mb-0 order-sm-2 order-lg-5">
            <span className="fw-600 d-block text-dark-gray mb-5px">Subscribe newsletter</span>
            <p className="lh-28 w-95 mb-10px xs-mb-10px">
              Subscribe our newsletter to get the latest news and updates!
            </p>
            <div className="d-inline-block w-100 newsletter-style-04 position-relative">
              <form
                action="#"
                method="post"
                className="position-relative w-100"
              >
                <input
                  className="fs-15 bg-white w-100 px-2 border border-1 border-color-dark-gray form-control required"
                  type="email"
                  name="email"
                  placeholder="Enter your email address"
                />
                <input type="hidden" name="redirect" value="" />
                <button className="btn submit me-2" aria-label="submit">
                  <i className="icon feather icon-feather-mail icon-small"></i>
                </button>
                <div className="form-results border-radius-0px p-15px fs-16 lh-24 w-100 text-center position-absolute d-none"></div>
              </form>
            </div>
          </div>
        </div>

        <div className="row justify-content-center align-items-center pt-7">
          <div className="col-12">
            <div className="divider-style-03 divider-style-03-01 border-color-extra-medium-gray"></div>
          </div>

          <div className="col-lg-5 pt-20px pb-20px md-pt-0 order-2 order-lg-1 text-center text-lg-start last-paragraph-no-margin fs-14">
            <p>
              &copy; 2025 <span className="fw-700 text-decoration-line-bottom">AL-NAKHBA</span> - All Rights Reserved | Powered By&nbsp;
              <a href="https://www.nelsistech.com/" target="_blank" className="text-dark-gray fw-600 text-decoration-line-bottom">
                Nelsis Tech
              </a>
            </p>
          </div>

          <div className="col-lg-7 pt-20px pb-20px md-pt-25px md-pb-5px order-1 order-lg-2 text-center text-lg-end fs-14">
            <ul className="footer-navbar sm-lh-normal">
              <li><a href="#" className="nav-link">Privacy policy</a></li>
              <li><a href="#" className="nav-link">Terms and conditions</a></li>
              <li><a href="#" className="nav-link">Copyright</a></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
